import "path";
import { readFile, writeFile } from "fs/promises";
import fetch from "node-fetch";
const prerender = true;
const fetchNew = process.env.npm_lifecycle_event === "build";
const filePath = "src/_games.json";
const playersPath = "src/_players.json";
function removeKey(obj, keysToRemove) {
  for (const prop in obj) {
    if (keysToRemove.includes(prop)) {
      delete obj[prop];
    } else if (typeof obj[prop] === "object") {
      removeKey(obj[prop], keysToRemove);
    } else
      ;
  }
}
const games = fetchNew ? await (await fetch(
  "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderby=%22season%22&equalto=%222023%22"
)).json() : (
  // :
  JSON.parse(await readFile(filePath, "utf8"))
);
if (fetchNew) {
  await writeFile(filePath, JSON.stringify(games));
  var dt = fetchNew ? await (await fetch(
    "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/players.json"
  )).json() : JSON.parse(await readFile(playersPath, "utf8"));
  if (fetchNew)
    await writeFile(playersPath, JSON.stringify(dt));
}
async function load({ fetch: fetch2, params }) {
  var currentDate = /* @__PURE__ */ new Date();
  var tenDaysAgo = new Date(currentDate);
  var tenDaysF = new Date(currentDate);
  tenDaysAgo.setDate(
    currentDate.getDate() - 28
    //7//10
  );
  tenDaysF.setDate(
    currentDate.getDate() + 28
    //7//10
  );
  var data = Object.values(games)?.filter(
    (v, i, l) => (v.firststart ?? v.start) < tenDaysF.toISOString() && (v.firststart ?? v.start) > tenDaysAgo.toISOString() || new Date(v.patch_startTimestamp ?? 0)?.toISOString() < tenDaysF.toISOString() && new Date(v.patch_startTimestamp ?? 0)?.toISOString() > tenDaysAgo.toISOString()
  )?.reduce((acc, currentValue, index) => {
    acc[index] = currentValue;
    return acc;
  }, {}) ?? await (await fetch2(
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json"
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderby=%22season%22&equalto=2023"
    // "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderby=%22season%22&equalto=%222023%22"
    "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderBy=%22start%22&startAt=%22" + tenDaysAgo.toISOString() + "%22&endAt=%22" + tenDaysF.toISOString() + "%22"
  )).json();
  removeKey(data, [
    "events",
    "fouls",
    "injurys",
    "corners",
    "shots",
    "offsides",
    "yellowcards",
    "home_lineup",
    "away_lineup",
    "home_substitutes",
    "away_substitutes",
    "crosss",
    "penaltys"
  ]);
  return data || {
    post: {
      title: `Title  goes here`,
      content: `Content  goes here`
    }
  };
}
export {
  load,
  prerender
};
